export default __webpack_public_path__ + "static/picto-info-light-blue-f7b9884a0c29a0ff371b48ad8165f496.png";